import React from "react";
import PropTypes from "prop-types";
import { logRuntimeError } from "utils/errorLog";

export class ErrorLogBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
    this.handleReset = this.handleReset.bind(this);
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    logRuntimeError(error, {
      reactErrorBoundary: true,
      componentStack: errorInfo?.componentStack,
    });
  }

  handleReset() {
    this.setState({ hasError: false });
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback != null) {
        return this.props.fallback;
      }
      return (
        <div className="p-4 text-center">
          <p className="mb-2">Something went wrong. A report was saved to the local error log.</p>
          <button type="button" className="btn btn-primary btn-sm" onClick={this.handleReset}>
            Try again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

ErrorLogBoundary.propTypes = {
  children: PropTypes.node,
  fallback: PropTypes.node,
};
